import { AppDispatch } from 'store';
import { notificationSlice } from 'store/slices';
import { Collaborator, Organization } from 'types';
import { ORDER_TYPE_TO_SURVEY_MAPPING, OrderSurveyData } from './types';

export const triggerPrePurchaseSurvey = (
  purchaser: Collaborator,
  organization: Organization,
  orderData: OrderSurveyData,
  dispatch: AppDispatch
) => {
  if (!purchaser?.email || !organization?.name) {
    console.error('Missing required data for Pre-Purchase survey:', {
      purchaserEmail: !!purchaser?.email,
      organizationName: !!organization?.name,
      orderData
    });
    return;
  }

  const surveyOrderType = ORDER_TYPE_TO_SURVEY_MAPPING[orderData.orderType] || orderData.orderType;

  const surveyPayload = {
    email: purchaser.email,
    name: `${purchaser.firstName} ${purchaser.lastName}`,
    properties: {
      orderNumber: orderData.orderNumber,
      orderType: surveyOrderType,
      organization: organization.name
    }
  };

  console.log('=== DELIGHTED SURVEY PAYLOAD ===');
  console.log('Survey payload:', surveyPayload);
  console.log('Raw order data:', orderData);
  console.log('Mapped order type:', surveyOrderType);
  console.log('================================');

  const surveyCall = `
    setTimeout(function() {
      console.log("Triggering Pre-Purchase Survey after order completion");
      if (typeof delightedSmileys !== 'undefined') {
        delightedSmileys.survey({
          email: "${purchaser.email}",
          name: "${purchaser.firstName} ${purchaser.lastName}",
          properties: {
            orderNumber: "${orderData.orderNumber}",
            orderType: "${surveyOrderType}",
            organization: "${organization.name}"
          }
        });
      } else {
        console.warn("Delighted survey script not loaded - delightedSmileys is not available");
      }
    }, 500);
  `;
  
  setTimeout(() => {
    try {
      // eslint-disable-next-line no-eval
      eval(surveyCall);
      console.log(`Triggered Pre-Purchase survey for order ${orderData.orderNumber} (${surveyOrderType})`);
    } catch (error) {
      console.error('Failed to trigger Pre-Purchase survey:', error);
      const errorMessage = error instanceof Error ? error.message : 'unknown error';
      dispatch(
        notificationSlice.actions.setNotice({
          showNotice: true,
          noticeContent: `Delighted Survey could not be displayed (${errorMessage})`,
        })
      );
    }
  }, 1000);
};

export const extractOrderNumber = (response: any, mutationName: string): string => {
  if (!response) {
    console.error('Invalid response structure in extractOrderNumber:', response);
    throw new Error('Response is undefined');
  }

  // Based on actual response structure: mutation data is directly on response object
  const mutationData = response[mutationName];
  
  if (!mutationData) {
    console.error(`Mutation data not found for ${mutationName}:`, response);
    throw new Error(`Mutation ${mutationName} not found in response`);
  }
  
  if (Array.isArray(mutationData)) {
    if (mutationData.length === 0) {
      console.error(`Empty array returned for ${mutationName}:`, mutationData);
      throw new Error(`No orders returned from ${mutationName}`);
    }
    return mutationData[0].orderNumber;
  } else {
    if (!mutationData.orderNumber) {
      console.error(`No orderNumber found in mutation data for ${mutationName}:`, mutationData);
      throw new Error(`No order number found in ${mutationName} response`);
    }
    return mutationData.orderNumber;
  }
}; 
